export const PASSPORT_REGEX = /^[A-Z]{2}[0-9]{6}$/;
